module.exports = __webpack_public_path__ + "images/listing-f48ba906269a4d8515c5a5f304191dd9.jpg";